'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasInitialMessagesToPublish = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _threadHistoryInvariant = require('../../invariants/threadHistoryInvariant');

var _messageTypeComparators = require('../../pubnub-message/operators/messageTypeComparators');

var _isPublished = require('../../pubnub-message/operators/isPublished');

var _getMessages = require('./getMessages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determines whether a thread has initial messages that
 * have yet to be published. This is a proxy for
 * whether we should hold off on sorting
 * thread history
 *
 * @param {ThreadHistory} threadHistory
 * @returns {boolean}
 */
var hasInitialMessagesToPublish = exports.hasInitialMessagesToPublish = (0, _curry2.default)(function (threadHistory) {
  (0, _threadHistoryInvariant.threadHistoryInvariant)(threadHistory);

  var messages = (0, _getMessages.getMessages)(threadHistory);

  return messages.some(function (message) {
    return (0, _messageTypeComparators.isInitialMessage)(message) && !(0, _isPublished.isPublished)(message);
  });
});